export const replaceProjectCoinTicker = (coinKey : string) => {
    return coinKey.replace('option_','').replace('Address','')
}

